import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';
import { SubCompetencia } from '@/app/models/interface/sub-competencia.model';

@Injectable({ providedIn: 'root' })
export class SubCompetenciasService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'sub-competencias/';

  create(data: Partial<SubCompetencia>) {
    return this.http.post<CustomResponse<SubCompetencia>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
            capacitaciones:
              d.capacitacionSubCompetencia?.map((y) => y.capacitacion) || [],
          };
        }
        return d;
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<SubCompetencia[], HasPagination>>
      >(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data:
                d.data.map((x) => ({
                  ...x,
                  capacitaciones:
                    x.capacitacionSubCompetencia?.map((y) => y.capacitacion) ||
                    [],
                })) || [],
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<SubCompetencia>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
            capacitaciones:
              d.capacitacionSubCompetencia?.map((y) => y.capacitacion) || [],
          };
        }
        return d;
      }),
    );
  }

  update(competencia: Partial<SubCompetencia>) {
    const url = this.url + competencia.id;
    return this.http.put<CustomResponse<SubCompetencia>>(url, competencia).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
            capacitaciones:
              d.capacitacionSubCompetencia?.map((y) => y.capacitacion) || [],
          };
        }
        return d;
      }),
    );
  }

  changeState(state: boolean, id: string) {
    const url = this.url + id;
    return this.http.patch<CustomResponse<SubCompetencia>>(url, { state }).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        if (d) {
          return {
            ...d,
            capacitaciones:
              d.capacitacionSubCompetencia?.map((y) => y.capacitacion) || [],
          };
        }
        return d;
      }),
    );
  }
}
